import React from "react";
import { Link } from "react-router-dom";
import { URLS } from "_configs/URLS";
import { useTranslation } from "react-i18next";

const LINKS = [
    {
        labelKey: "footer.links.contactUs",
        url: URLS.contact(),
    },
    {
        labelKey: "footer.links.properties",
        url: URLS.buy(),
    },
    {
        labelKey: "footer.links.policy",
        url: URLS.policy(),
    },
    {
        labelKey: "footer.links.terms",
        url: URLS.terms(),
    },
    {
        labelKey: "footer.links.faq",
        url: URLS.faq(),
    },
];

export function FooterLink() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center md:flex-row md:justify-center">
            {LINKS.map((link) => (
                <div
                    key={link.url}
                    className="flex items-center justify-center w-full md:w-60 md:border-r border-b md:border-b-0 border-white last:border-r-0 justify-center text-center h-[60px] md:h-[22px]"
                >
                    <Link to={link.url} className={"!text-white text-xs"}>
                        {t(link.labelKey)}
                    </Link>
                </div>
            ))}
        </div>
    );
}
